import { IFilterField } from 'models/types';
import { useTranslation } from 'react-i18next';

export const useWomeApplicationFilterSchema = (): IFilterField[] => {
  const { t } = useTranslation('default');
  return womeApplicationFilterSchema(t);
};

export const womeApplicationFilterSchema = (t: (key: string) => string): IFilterField[] => {
  return [
    {
      label: t('name-contains'),
      name: 'name',
      widget: 'text',
    },
  ];
};
